/****************************************************
* Module Name:  ProcessMasterProxy.js
* Project:      Pansuriya Impex Sales & Manufacturing
* Owner:        info@pansuriyaimpex.com
*
* Copyright (c) Pansuriya Impex
* All rights reserved.
****************************************************/

import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class ProcessMasterProxy {
    static CheckProcessAvailable = (process, callback) => {
        let params = {
            process: process,
        };

        restAPICall(
            Constants.MANAGER_URL + "/mfgprocess/available",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetAllProcess = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/mfgprocess",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetAllProcessDetails = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/mfgprocess/detail",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static AddProcess = (process, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/mfgprocess",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(process),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static UpdateProcess = (process, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/mfgprocess",
            "put",
            Constants.userToken,
            undefined,
            JSON.stringify(process),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

}